import { createFileRoute } from '@tanstack/react-router';

import { PlayerAchievementsPageWidget } from '@features/user/pages/PlayerAchievementsPage/PlayerAchievementsPageWidget';

export const Route = createFileRoute('/profile/achievements/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PlayerAchievementsPageWidget />;
}
